import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import TextInput from "../TextInput/TextInput"; // Assuming it's your custom MUI input

const CustomAutoComplete = styled(Autocomplete)({
    "& .MuiAutocomplete-inputRoot": {
        padding: 0,
        "& .MuiAutocomplete-input": {
            padding: "18.5px 14px !important",
        },
    },
});

const AutoCompleteSelect = ({
    label,
    options = [],
    size,
    _key,
    getOptionLabel,
    getOptionSelected,
    loading,
    handleChange = (val) => { },
    selectedValue,
    error,
    customInput,
    ...props
}) => {
    const [value, setValue] = useState(null);
    const [customOption, setCustomOption] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const onChange = (e, newValue) => {
        setValue(newValue);
        handleChange(newValue);
        setInputValue("");
    };

    useEffect(() => {
        if (selectedValue && typeof selectedValue === "object" && Object.keys(selectedValue).length) {
            setValue(selectedValue);
        } else {
            setInputValue(selectedValue || "");
        }
    }, [selectedValue, _key, options]);

    const onInputChange = (e, newValue) => {
        const replacedChar = String(newValue.replace(/[^0-9]/g, ""));
        setInputValue(customInput ? replacedChar : newValue);

        if (customInput) {
            if (
                replacedChar >= customInput.min &&
                replacedChar <= customInput.max &&
                !options.some((item) => String(item) === replacedChar)
            ) {
                setCustomOption([String(replacedChar)]);
            } else {
                setCustomOption([]);
            }
        }
    };

    return (
        <CustomAutoComplete
            disablePortal
            disableClearable
            blurOnSelect
            options={customInput ? [...customOption, ...options] : options}
            onChange={onChange}
            onInputChange={onInputChange}
            getOptionLabel={getOptionLabel}
            getOptionSelected={getOptionSelected}
            value={value || null}
            inputValue={inputValue || ""}
            {...props}
            renderInput={(params) => (
                <TextInput
                    {...params}
                    {...props}
                    error={error}
                    value={inputValue || ""}
                    label={label}
                    size={size}
                />
            )}
        />
    );
};

export default React.memo(AutoCompleteSelect);
